import { dynamicPackageAttractionLineBillableToCustomer } from "../packageAttractionRulesDisplay";
import { mergeAttractionPricingLayers } from "./mergeAttractionPricingLayers.js";

/**
 * @param {unknown} v
 * @returns {number|null}
 */
function pickPositive(v) {
  const n = Number(v);
  return Number.isFinite(n) && n > 0 ? n : null;
}

/**
 * מחיר יחידה לאופציונלי (ILS) — קודם משורת חבילה חייבת, אחר כך שדות בחוק/קטלוג;
 * base_price רק כש־per_person (כמו resolveAdultChildUnitPricesIls).
 *
 * @param {Record<string, unknown>|null|undefined} rule
 * @param {Record<string, unknown>|null|undefined} line
 * @returns {number|null}
 */
export function resolveOptionalUnitPriceIls(rule, line) {
  if (line && typeof line === "object" && dynamicPackageAttractionLineBillableToCustomer(line)) {
    const tg = Number(line.total_gross);
    if (Number.isFinite(tg) && tg > 0) return tg;
  }
  if (!rule || typeof rule !== "object") return null;
  const cat =
    rule.catalog && typeof rule.catalog === "object" ? rule.catalog : null;

  const scalar =
    pickPositive(rule.sell_value) ??
    pickPositive(rule.price_value) ??
    pickPositive(cat?.sell_value) ??
    pickPositive(cat?.price_value);
  if (scalar != null) {
    return scalar;
  }

  const flat = mergeAttractionPricingLayers(rule, cat);

  const keys = [
    "customer_price_ils",
    "retail_price_ils",
    "list_price_ils",
    "addon_price_ils",
    "unit_price_ils",
    "marketing_price_ils",
    "dynamic_package_addon_price_ils",
    "suggested_price_ils",
    "price_adult",
    "sell_value",
    "price_value",
    "price_amount",
  ];
  for (const k of keys) {
    const v = Number(flat[k]);
    if (Number.isFinite(v) && v > 0) return v;
  }

  const pricingModel = String(
    flat.default_pricing_model || flat.pricing_model || ""
  ).toLowerCase();
  if (pricingModel === "per_person") {
    const bp = pickPositive(flat.base_price);
    if (bp != null) return bp;
  }
  return null;
}
